module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/commercial-real-estate-loans-banner.jpg",
            "altText": "A background of commercial properties",
            "ctaButtonTitle": "Check Eligibility"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Commercial Real Estate Loans")]), _vm._v(" "), _c('p', [_vm._v("Business Loans | Fast Funding")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering businesses everyday with commercial real estate loans.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Whether you’re a developer, investor, or business owner looking to finally purchase  or refinance your property, American Credit can help. We offer commercial property loans for different uses, including purchasing or refinancing  industrial properties & warehouses, retail properties, multi-family properties, and commercial office buildings. We also have a wide variety of custom real estate financing solutions. They range from No-Ratio, Stated Income, Bank Statements Only, Full-Doc, to No-Doc Loans. Besides conventional loans, we also offer bridge loans, fix & flip/ fix & hold, as we as SBA/business loans.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          Read on and see how we help people just like you receive Commercial Real Estate loans everyday. \n          "), _c('br')])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/commercial-real-estate-loans1.jpg",
            "altText": "A comercial property by the street",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE",
            "displayCtaButton": false
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Commercial Property Loans")]), _vm._v(" "), _c('p', [_vm._v("\n         Utilize your Commercial Construction Loan to purchase the land or commercial property your business needs. Use your Commercial Property Loan to invest in a multi-family unit rental property like an apartment complex, purchase a commercial office building, or renovate your recently purchased commercial property. \n          Moreover, we also provide loans for commercial condos, mixed use, gas stations, and church financing.\n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          When it comes to Commercial Real Estate Financing, you have the luxury of utilizing your business loan to best serve your need. Call us to learn more about how we can help you get the Commercial Real Estate financing you need in a hurry.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/commercial-real-estate-loans2.jpg",
            "altText": "Commercial properties by the street",
            "displayCtaButton": false
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Commercial Real Estate Financing for New Property Construction")]), _vm._v(" "), _c('p', [_vm._v("\n          Looking to create a brand new property with your Commercial Construction Loan? For some commercial real estate investors & business owners, building a commercial property from the ground up is a better long-term investment. \n          "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          Use your Commercial Real Estate loan to finance the construction of your brand new commercial property. Your Commercial Property Loan can finance any needed construction labor & equipment. This loan type is often used for the purchase of immediate supplies & construction equipment, meeting immediate employee payroll, and more. Whatever the need, your Commercial Property Loan can assist you with the overall goal of obtaining your very own commercial property. \n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Construction Loan Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9dd15384"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/commercialRealEstateLoans.vue
// module id = 2009
// module chunks = 5